import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemAgitation } from './components/ProblemAgitation';
import { NotYourFault } from './components/NotYourFault';
import { Mechanism } from './components/Mechanism';
import { ProductIntro } from './components/ProductIntro';
import { NightByNight } from './components/NightByNight';
import { ForWhom } from './components/ForWhom';
import { Testimonials } from './components/Testimonials';
import { AboutAuthor } from './components/AboutAuthor';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyUrgencyBar } from './components/StickyUrgencyBar';
import { initPixel, trackPageView } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream-50 font-sans text-slate-800" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemAgitation data-id="element-2" />
      <NotYourFault data-id="element-3" />
      <Mechanism data-id="element-4" />
      <ProductIntro data-id="element-5" />
      <NightByNight data-id="element-6" />
      <ForWhom data-id="element-7" />
      <Testimonials data-id="element-8" />
      <AboutAuthor data-id="element-9" />
      <Offer data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <FAQ data-id="element-13" />
      <Footer data-id="element-14" />
      <StickyUrgencyBar data-id="element-15" />
    </div>;
}